export const DONATION_URL =
  "https://www.fondation-patrimoine.org/les-projets/restauration-du-temple-de-sommieres" +
  "?utm_source=site_asts&utm_medium=referral&utm_campaign=don_temple";
